import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Title } from '@angular/platform-browser';

import { SeoService } from '../../services/seo.service';

interface TreeLink {
  label: string;
  description: string;
  href: string;
  icon: string;
}

@Component({
  selector: 'app-tree',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './tree.component.html',
  styleUrl: './tree.component.scss',
})
export class TreeComponent implements OnInit, OnDestroy {
  private readonly title = inject(Title);
  private readonly seo = inject(SeoService);

  protected readonly links: TreeLink[] = [
    {
      label: 'Website',
      description: 'Finde saubere Toiletten an Raststätten',
      href: 'https://rast-wc.de/',
      icon: 'language',
    },
    {
      label: 'Instagram',
      description: 'Folge Rast-WC auf Instagram',
      href: 'https://www.instagram.com/rastwc/',
      icon: 'photo_camera',
    },
    {
      label: 'Rast-WC App',
      description: 'Jetzt im Google Play Store herunterladen',
      href: 'https://play.google.com/store/apps/details?id=de.rwc.app',
      icon: 'play_arrow',
    },
  ];

  ngOnInit(): void {
    this.title.setTitle('Rast-WC.de – Alle Links');
    this.seo.updateMetaDescription('Alle wichtigen Links von Rast-WC.de: Website, Instagram und Android-App.');
    this.seo.updateCanonicalUrl('https://rast-wc.de/tree');
  }

  ngOnDestroy(): void {
    this.seo.resetMetaDescription();
    this.seo.resetCanonicalUrl();
  }
}
